import config from '@/config'
import Log from '@/utilities/Log'
import resetStore from '@/components/use/resetStore'
import { useUserStore } from '@/storage/user'
import type { AuditableEventType } from '@/handlers/terminateSession'

export interface AdministratorCheckoutEventData extends AuditableEventType {
  reason?: string
}

async function administratorCheckout(data: AdministratorCheckoutEventData) {
  const checkInSameTimeOrLaterThanEvent =
    new Date(useUserStore().checkedInTime ?? 0) >= new Date(data.occurredAt)
  if (checkInSameTimeOrLaterThanEvent) {
    return
  }

  resetStore()
  Log.storeReset('administratorCheckout.ts')

  const url = new URL(config.redirects.sessionExpired)
  if (data.reason) {
    url.searchParams.set('reason', data.reason)
  }
  window.location.replace(url.toString())
}

export default administratorCheckout
